export class Nivel {
  nivelId: number;
  clave: string;
  nombre: string;
  FechaCreacion: Date;
  UsuarioCreacion: number;
  FechaModificacion: Date;
  UsuarioModificacion: number;
}
